import classNames from "classnames";
import atDemo from "../../../assets/logos/at-demo_logo.png";
import hosLogo from "../../../assets/logos/HÖS/HÖS.jpg";
import ljungbyLogo from "../../../assets/logos/Ljungby_logo.png";
import umeaLogo from "../../../assets/logos/Umea/Umea.png";
import hulLogo from "../../../assets/logos/Uppsala_logo.png";
import { isHOS, isHUL, isLJUNGBY, isUMEA } from "../../../utils/siteEvaluator";
import Image from "../../shared/Image/Image";
import HÖSMunicipalityLogo from "../../shared/MunicipalityLogo/HÖSMunicipalityLogo";
import MunicipalityLogo from "../../shared/MunicipalityLogo/MunicipalityLogo";
import styles from "./SiteAssets.module.scss";

export function SiteLogo(): JSX.Element {
  if (isHUL()) {
    return <Image src={hulLogo} alt="Uppsala - Logotyp" customCssClass={styles.imageContainer} />;
  }

  if (isHOS()) {
    return <Image src={hosLogo} alt="Hjälpmedelscentralen - Logo" customCssClass={styles.imageContainer} />;
  }

  if (isLJUNGBY()) {
    return <Image src={ljungbyLogo} alt="Ljungby - Logo" customCssClass={styles.imageContainer} />;
  }

  if (isUMEA()) {
    return <Image src={umeaLogo} alt="Umeå - Logo" customCssClass={styles.imageContainer} />;
  }

  return <Image src={atDemo} alt="Myloc logo" customCssClass={styles.imageContainer} />;
}

export function CompanyLogoList() {
  return (
    <section className={classNames(styles.list, styles.companyLogoSegment)}>
      {isHUL() ? <HULCompanyLogoList /> : isHOS() ? <HOSCompanyLogoList /> : null}
    </section>
  );
}

function HULCompanyLogoList() {
  return (
    <>
      <MunicipalityLogo id="Heby" customCssClass={styles.logo} />
      <MunicipalityLogo id="Habo" customCssClass={styles.logo} />
      <MunicipalityLogo id="Enkoping" customCssClass={styles.logo} />
      <MunicipalityLogo id="Osthammar" customCssClass={styles.logo} />
      <MunicipalityLogo id="Tierp" customCssClass={styles.logo} />
      <MunicipalityLogo id="Knivsta" customCssClass={styles.logo} />
    </>
  );
}

function HOSCompanyLogoList() {
  return (
    <>
      <HÖSMunicipalityLogo id="Kristianstad" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Bromölla" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Hässleholm" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Hörby" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Osby" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Simrishamn" customCssClass={styles.specialLogo} />
      <HÖSMunicipalityLogo id="ÖstraGöinge" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Tomelilla" customCssClass={styles.logoNoWidth} />
      <HÖSMunicipalityLogo id="Ystad" customCssClass={styles.logo} />
      <HÖSMunicipalityLogo id="Sjöbo" customCssClass={styles.specialLogo} />
      <HÖSMunicipalityLogo id="Skurup" customCssClass={styles.specialLogo} />
    </>
  );
}
